<template>
    <q-list>
        <q-collapsible class="filter" icon="fal fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
            <q-list no-border>
                <q-item>
                    <q-item-main>
                        <q-search v-model="search" :placeholder="$t('search')" icon="fal fa-search" @input="changeFilter" :debounce="600" />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="caption">{{ $t('progress') }}</p>
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('all'), value: 'all', icon: 'fal fa-list'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('in_progress'), value: 'in-progress', icon: 'fal fa-shoe-prints'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('to_do'), value: 'to-do', icon: 'fal fa-edit'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="progress"
                            toggle-color="primary"
                            :options="[
                                {label: $t('finished'), value: 'finished', icon: 'fal fa-check-circle'}
                            ]"
                            @input="changeFilter"
                        />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="caption">{{ $t('favorites') }}</p>
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="favorite"
                            toggle-color="primary"
                            :options="[
                                {label: $t('all'), value: 'all', icon: 'fal fa-list'}
                            ]"
                            @input="changeFilter"
                        />
                        <q-btn-toggle
                            class="full-width q-mb-sm progress"
                            v-model="favorite"
                            toggle-color="primary"
                            :options="[
                                {label: $t('favorites'), value: 'favorites', icon: 'fal fa-heart'}
                            ]"
                            @input="changeFilter"
                        />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="text-center">
                            <a href="#" @click.prevent="clearFilters()" class="text-faded">
                                <q-icon name="fal fa-trash-alt" /> {{ $t('clear_filters') }}
                            </a>
                        </p>
                    </q-item-main>
                </q-item>
            </q-list>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            search: '',
            progress: 'all',
            favorite: 'all'
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            store_search: 'presential/search',
            store_progress: 'presential/progress',
            store_favorite: 'presential/favorite'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        changeFilter() {
            this.$store.dispatch('presential/SET_FILTERS', [this.search, this.progress, this.favorite])
            this.$emit('changeFilter')
        },

        clearFilters() {
            this.$store.dispatch('presential/SET_FILTERS', ['', 'all', 'all'])
            this.$emit('changeFilter')
            this.search   = '',
            this.progress = 'all',
            this.favorite = 'all'
        },
    },

    created() {
        this.clearFilters()
        this.search = this.store_search
        this.progress = this.store_progress
        this.favorite = this.store_favorite
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

p
    &.tags
        margin 0 0 5px

a
    text-decoration none
</style>
